import { COLORS } from "../../theme/colors";

export const GLANCE_RATES = {
  good: 1,
  bad: 2,
};

export const GLANCE_PARAMS = {
  rental_revenue: "rental_revenue",
  vacancy: "vacancy",
  carbon_reduction: "carbon_reduction",
  connected_tenant: "connected_tanant",
  power_trading_revenue: "power_trading_revenue",
  power_asset_revenue: "power_asset_revenue",
  noi_increase: "noi_increase",
  building_profitability: "building_profitability",
};

export const ANY_FILTER_KEY = "any";

export const ITEMS_PER_PAGE = 10;

export const STATUS_MAP = {
  RENTED: "Rented",
  ECONOMIC_VACANCY: "Economic vacancy",
  PHYSICAL_VACANCY: "Physical vacancy",
  CONNECTED: "Connected",
  READY: "Ready to connect",
  STAND_BY: "Stand-by",
  PENDING: "Pending",
  MISSING: "Missing",
  IN_PROGRESS: "In progress",
};

export const TENANTS_CONNECTION_STATUS_LEGEND_COLORS = {
  fully_connected: COLORS.green,
  partially_connected: COLORS.purple,
  unconnected: COLORS.red,
};

export const CONNECTION_STATUS_LEGEND_COLORS = {
  connected: COLORS.green,
  ready_to_connect: COLORS.purple,
  stand_by: COLORS.orange,
  pending: COLORS.lightBlues[0][100],
  missing: COLORS.red,
};

export const CONNECTION_STATUS_PIE_DATA = [
  {
    name: "connected",
    value: 0,
    legendValue: 0,
    key: "connected",
    middleLabel: "are",
    bottomLabel: "connected",
  },
  {
    name: "ready",
    value: 0,
    legendValue: 0,
    key: "ready_to_connect",
    middleLabel: "are ready to be",
    bottomLabel: "connected",
  },
  {
    name: "stand_by",
    value: 0,
    legendValue: 0,
    key: "stand_by",
    middleLabel: "are in",
    bottomLabel: "stand by",
  },
  {
    name: "pending",
    value: 0,
    legendValue: 0,
    key: "pending",
    middleLabel: "are in",
    bottomLabel: "pending",
  },
  {
    name: "missing",
    value: 0,
    legendValue: 0,
    key: "missing",
    middleLabel: "are",
    bottomLabel: "missing",
  },
];

export const TENANTS_CONNECTION_STATUS_PIE_DATA = [
  {
    name: "fully_connected",
    value: 0,
    legendValue: 0,
    key: "fully_connected",
    middleLabel: "are fully",
    bottomLabel: "connected",
  },
  {
    name: "partially_connected",
    value: 0,
    legendValue: 0,
    key: "partially_connected",
    middleLabel: "are partially",
    bottomLabel: "connected",
  },
  {
    name: "unconnected",
    value: 0,
    legendValue: 0,
    key: "unconnected",
    middleLabel: "are",
    bottomLabel: "unconnected",
  },
];

export const unrealizedTradingRevenuesBars = [
  {
    dataKey: "unconnected_tenants",
    fill: "#E1C9A7",
  },
  {
    dataKey: "economic_vacancy",
    fill: "#D3CCC1",
  },
  {
    dataKey: "physical_vacancy",
    fill: "#E4DCD1",
  },
];

export const unrealizedTradingRevenuesGraphItems = [
  {
    name: "Physical vacancy",
    color: "#D3CCC1",
  },
  {
    name: "Economic vacancy",
    color: "#E4DCD1",
  },
  {
    name: "Unconnected tenants",
    color: "#E1C9A7",
  },
];

export const getProfitabilityComponentsTableHeader = (unitSystem) => [
  "Usage Type",
  "Total Monthly",
  "Total Yearly",
  `Total Yearly/${unitSystem}`,
  "Portfolio avg.",
  "Industry avg.",
];

export const profitabilityComponentsTableTypeName = {
  rent_revenue: "Rent revenue",
  rental_cost_building_owner: "Rental costs paid to building owner",
  rent_margin: "Rent Margin",
  electricity_consumption: "Electricity consumption",
  electricity_revenue: "Electricity Revenue",
  electricity_cost: "Electricity Costs",
  electricity_margin: "Electricity Margin",
  praas_trading_revenue: "PRaaS Trading Revenue",
  praas_electricity_supply_revenue: "PRaaS Electricity Supply Revenues",
  tenants_rebate: "Tenants Rebate",
  praas_batteries_revenue: "PRaaS Batteries Revenues",
  praas_ev_revenue: "PRaaS EV Revenues",
  praas_solar_revenue: "PRaaS Solar Revenues",
  total_revenue: "Total Revenues",
  unrealized_revenues: "Unrealized PRaaS Revenues",
};

export const profitabilityComponentsTableRowStyle = {
  praas_trading_revenue: { backgroundColor: COLORS.purples[10] },
  praas_electricity_supply_revenue: { backgroundColor: COLORS.purples[10] },
  unrealized_revenues: { backgroundColor: "rgba(225, 201, 167, 0.2)" },
};

export const powerConsumptionOverTimeAreas = [
  {
    key: "consumption",
    stroke: COLORS.purple,
    fill: COLORS.purple,
  },
];
export const unitComparisonChartLines = [
  {
    dataKey: "_unit",
    stroke: COLORS.purple,
  },
  {
    dataKey: "avg_building",
    stroke: COLORS.blue,
  },
  {
    dataKey: "avg_portfolio",
    stroke: "#666666",
  },
  {
    dataKey: "avg_industry",
    stroke: COLORS.darks[0][100],
  },
];
export const revenueBreakdownOverTimeChartLines = [
  {
    key: "rental_revenue",
    dataKey: "Rental revenue",
    fill: COLORS.cian,
    stroke: COLORS.cian,
    onlyBorder: false,
  },
  {
    key: "actual_power_rev",
    dataKey: "Actual power revenue",
    fill: COLORS.purple,
    stroke: COLORS.purple,
    onlyBorder: false,
  },
  {
    key: "tenants_rebate",
    dataKey: "Tenant rebate",
    fill: COLORS.grey,
    stroke: COLORS.grey,
    onlyBorder: false,
  },
  {
    key: "potential_power_rev",
    dataKey: "Potential power revenue",
    onlyBorder: true,
    fill: COLORS.purple,
    stroke: COLORS.purple,
  },
];

export const comparisonChartLines = [
  {
    dataKey: "tenant",
    stroke: COLORS.purple,
    name: "This tenant (all meters)",
  },
  {
    dataKey: "building",
    stroke: COLORS.blue,
    name: "This building",
  },
  {
    dataKey: "avg_portfolio",
    stroke: COLORS.spanishGray,
    name: "Avg. Portfolio",
  },
  {
    dataKey: "avg_industry",
    stroke: COLORS.darks[0][100],
    name: "Avg. Industry",
  },
];

export const comparisonGraphFooter = [
  {
    name: "Tenant (Aggregated meters)",
    color: COLORS.purple,
  },
  {
    name: "Avg. building",
    color: COLORS.blue,
  },
  {
    name: "Avg. portfolio",
    color: COLORS.spanishGray,
  },
  {
    name: "Avg. Industry",
    color: COLORS.darks[0][100],
  },
];
export const revenueGraphFooter = [
  {
    name: "Potential power revenue",
    color: COLORS.purple,
    onlyBorder: COLORS.purple,
  },
  {
    name: "Actual power revenue",
    color: COLORS.purple,
  },
  {
    name: "Tenants Rebate",
    color: COLORS.grey,
  },
  {
    name: "Rental revenue",
    color: COLORS.cian,
  },
];
export const unitGraphFooter = [
  {
    name: "Unit",
    color: COLORS.purple,
  },
  ...comparisonGraphFooter.slice(1, 4),
];

export const profileGraphFooter = [
  {
    name: "This Tenant",
    color: COLORS.purple,
  },
  ...comparisonGraphFooter.slice(1, 4),
];

export const tenancyChartBars = [
  {
    dataKey: "_unit",
    fill: COLORS.purple,
    barSize: 24,
    unit: "nFormatter",
  },
  {
    dataKey: "building",
    fill: COLORS.blue,
    barSize: 24,
    unit: "nFormatter",
  },
  {
    dataKey: "portfolio",
    fill: COLORS.spanishGray,
    barSize: 24,
    unit: "nFormatter",
  },
  {
    dataKey: "industry",
    fill: COLORS.darks[0][100],
    barSize: 24,
    unit: "nFormatter",
  },
];

export const powerConsumptionCostsChartBars = [
  {
    dataKey: "building",
    fill: COLORS.blue,
    barSize: 30,
  },
  {
    dataKey: "portfolio",
    fill: COLORS.spanishGray,
    barSize: 30,
  },
  {
    dataKey: "industry",
    fill: COLORS.darks[0][100],
    barSize: 30,
  },
];

export const vacancyKeys = ["physical_vacancy", "economic_vacancy"];
